"use client";

import React from "react";
import { defaultTheme } from "@/src/config/colors";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverable?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = "",
  hoverable = false,
}) => {
  return (
    <div
      className={`rounded-lg overflow-hidden transition-all duration-200 ${
        hoverable
          ? "hover:shadow-lg hover:scale-105 cursor-pointer"
          : "shadow-md"
      } ${className}`}
      style={{
        backgroundColor: defaultTheme.background,
        borderColor: defaultTheme.border,
      }}
    >
      {children}
    </div>
  );
};
